import React from "react";
import { Text, Spacer, Image } from "../dynamic.components";
import fiber_cartridges from "src/assets/images/cartridge/fiber_cartridge.png";
import fiber_cartridges_table from "src/assets/images/cartridge/fiber_cartridge_table.png";
import SubHotspots from "../Sub-hotspots";

export const HollowFiberCartridges: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <Text text="The ÄKTA readyflux™ mounting brackets for hollow fiber (HF) cartridges provides a convenient way to place and use HF cartridges for filtration." />
        <Spacer />
        <SubHotspots sublinkId="2-2" />
        <Spacer />
        <Text text="HF cartridges are provided with two side connections to the permeate compartment, one in each end." />
        <Text text="The HF cartridge is mounted vertically, so the lower side connection serves as a drain for the permeate." />
        <Text text="This allows for more complete recovery of the permeate" />
        <Spacer />
        <Text text="The mounting brackets offer the ability to mount one or two HF cartridges" />
        <Spacer />
        <Image
          images={[
            {
              src: fiber_cartridges,
              alt: "Fiber cartridges",
              customWidth: "70%",
            },
            {
              src: fiber_cartridges_table,
              alt: "Fiber cartridges table",
              customWidth: "50%",
            },
          ]}
        />
      </div>
    </>
  );
};
